import request from '@/config/axios'

const base = (userMode = false) => `/bosscircle/${userMode ? 'user-news' : 'news'}`
export const getNewsPage = (params: any, userMode = false) =>
  request.get({ url: `${base(userMode)}/page`, params })
export const getNews = (id: number, userMode = false) =>
  request.get({ url: `${base(userMode)}/get`, params: { id } })
export const saveNews = (data: any, userMode = false) =>
  userMode
    ? request.put({ url: `${base(true)}/save`, data })
    : request.post({ url: `${base(false)}/save`, data })
export const auditNews = (
  id: number,
  auditStatus: number,
  auditRemark?: string,
  userMode = false
) => request.put({ url: `${base(userMode)}/audit`, params: { id, auditStatus, auditRemark } })
export const getNewsAuditCounts = () =>
  request.get<Record<number, number>>({ url: `${base(true)}/audit-counts` })
export const batchAuditNews = (ids: number[], auditStatus: number, auditRemark?: string) =>
  request.put({
    url: `${base(true)}/batch-audit`,
    params: { ids: ids.join(','), auditStatus, auditRemark }
  })
export const updateNewsStatus = (id: number, status: number, userMode = false) =>
  request.put({ url: `${base(userMode)}/status`, params: { id, status } })
export const batchUpdateNewsStatus = (ids: number[], status: number, userMode = false) =>
  request.put({ url: `${base(userMode)}/batch-status`, params: { ids: ids.join(','), status } })
export const deleteNews = (id: number, userMode = false) =>
  request.delete({ url: `${base(userMode)}/delete`, params: { id } })
export const batchDeleteNews = (ids: number[], userMode = false) =>
  request.delete({ url: `${base(userMode)}/batch-delete`, params: { ids: ids.join(',') } })
